<template>
 <div class="container">
    <div class="content animate__animated animate__fadeIn">
      <router-link :to="{path:'/xmditu'}">
        <div class="title">
          <!-- <img src="../assets/img/cc.png"  class="titleimg" />
          <div class="btn"><img src="../assets/img/link.png" />项目地图</div> -->
        </div>
      </router-link>
        <div class="circleBox">
          <div class="circle1">
            <router-link :to="{path:'/xiaofeiData'}">
            <div class="circleA" >
              <div class="circleB"></div>
              <div class="info">
                  <img :src="url+'/img/xf.png'" class=" animate__animated animate__zoomIn img1" />
                  <div class="fontStyle fontStyle1 color1">消费</div>
                  <div class="fontStyle2">电商数据</div>
                  <div class="jiantou"><img :src="url+'/img/jt1.png'" class="img2" /></div>
                  <div class="infoBottom">
                    <div class="infoBottomItem"><span class="fontStyle3 color1 animate__animated animate__bounceIn">5.2</span><span class="fontStyle4">%</span><span  class="fontStyle5">年增长幅度</span></div>
                    <div class="infoBottomItem"><span class="fontStyle3 color1 animate__animated animate__bounceIn">43.7</span><span class="fontStyle4">亿元</span><span  class="fontStyle5">电商交易额</span></div>
                  </div>
                </div>
            </div>
            </router-link>
            <!-- <div ref="canvasContainer" class="dizuo"></div> -->
            <img :src="url+'/img/ldz1.png'" class="dizuo" />
          </div>
          <div class="circle1">
            <router-link :to="{path:'/jiagong'}">
            <div class="circleA">
              <div class="circleB"></div>
              <div class="info">
                  <img :src="url+'/img/jg.png'" class=" animate__animated animate__zoomIn img1" />
                  <div class="fontStyle fontStyle1 color2">加工</div>
                  <div class="fontStyle2">电商产品</div>
                  <div class="jiantou"><img :src="url+'/img/jt2.png'" class="img2" /></div>
                  <div class="infoBottom">
                    <div class="infoBottomItem"><span class="fontStyle3 color2 animate__animated animate__bounceIn">5.5</span><span class="fontStyle4">%</span><span  class="fontStyle5">年增长幅度</span></div>
                    <div class="infoBottomItem"><span class="fontStyle3 color2 animate__animated animate__bounceIn">14.7</span><span class="fontStyle4">亿元</span><span  class="fontStyle5">网络销售额</span></div>
                  </div>
                </div>
            </div>
            </router-link>
            <img :src="url+'/img/ldz2.png'" class="dizuo" />
          </div>
          <div class="circle1">
            <router-link :to="{path:'/gbzntyj'}">
            <div class="circleA">
              <div class="circleB"></div>
              <div class="info">
                  <img :src="url+'/img/zz.png'" class=" animate__animated animate__zoomIn img1" />
                  <div class="fontStyle fontStyle1 color3">种植</div>
                  <div class="fontStyle2">高标农田</div>
                  <div class="jiantou"><img :src="url+'/img/jt3.png'" class="img2" /></div>
                  <div class="infoBottom">
                    <div class="infoBottomItem"><span class="fontStyle3 color3 animate__animated animate__bounceIn">30</span><span class="fontStyle4">%</span><span  class="fontStyle5">项目已完成</span></div>
                    <div class="infoBottomItem"><span class="fontStyle3 color3 animate__animated animate__bounceIn">50000</span><span class="fontStyle4">亩</span><span  class="fontStyle5">高标示范田</span></div>
                  </div>
                </div>
            </div>
            </router-link>
            <img :src="url+'/img/hdz3.png'" class="dizuo" />
          </div>
        </div>
        <!-- <div class="bottom">
          
        </div> -->
        
        <img :src="url+'/img/gx.png'" class="bottom" />
        <!-- <img src="../assets/img/gx.png" class="bottom1" /> -->
    </div>
    <div  id="iviewBg" class="bolang"></div>
    
 </div>
 <footer1 />

 <!-- <div class="bg" v-if="isShow"><img src="../assets/img/bg.gif" /></div> -->
 <!-- <img src="../assets/images/bg.gif" /> -->
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";


import { setInterval, clearInterval } from "timers";
import { stat } from 'fs';
// import footer from '../components/footer.vue'
import footer1 from "../components/footer.vue";

// import waterimg from "@/assets/img/ldz1.png"


export default {
  name: "Home",
  props: {
  	//控制x轴波浪的长度
    amountX: {
      type: Number,
      default: 50,
    },
    //控制y轴波浪的长度
    amountY: {
      type: Number,
      default: 30,
    },
    //控制点颜色
    color: {
      type: String,
      default: "#67F2EB",
    },
    //控制波浪的位置
    top: {
      type: Number,
      default: 350,
    },
  },
  setup(props) {
    const SEPARATION = 90;

    // let stats;
    let container, camera, scene, renderer;

    let particles,
      count = 0;

    let mouseX = 0;

    let windowHalfX = window.innerWidth / 2;

    const { proxy } = getCurrentInstance();
    const timer = ref(null);
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      videoShow:false,
      options:{
        src: "", //视频源
        type: 'm3u8', //视频类型
      },
      isShow:false
    });
    onMounted(() => {
      clearInterval(timer.value);
      timer.value = setInterval(() => {
        state.currentTime = proxy.$utils.getCurrentTime();
      }, 1000);
      setTimeout(() => {
        state.isShow = true
      }, 3000);


      // getData();

      init();
      animate();

    });

    onBeforeUnmount(() => {
      clearInterval(timer.value);
    })
    const onPlay = (ev) => {
      console.log('播放')
    }


    function getData() {
      axios
        .post("https://farmmanagement.laicunwang.com/api/index/hqhzsindex", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
        .then((res) => {
          console.log(res);
          let data = res.data.data;
          // 左一   
            state.leftData= data[0]
          // 左二   
            state.cangchuList = [{id:1,name:'库存量',value:data[1].kcl},{id:2,name:'入库量',value:data[1].rkl},{id:3,name:'出库量',value:data[1].ckl}]
            state.left2Data = [data[1].sz,data[1].bz]
          // 左三  

          // 中间一 
            // 处理数据
            let centerData1 =[
              {id:1,name:"种植面积/亩",value:data[2].zzmj},
              {id:2,name:"产品预测/吨",value:data[2].cpyc},
              {id:3,name:"花生出库量/吨",value:data[2].hsck},
              {id:4,name:"服务人数/人",value:data[2].fwrs},
              {id:5,name:"处理问题/条",value:data[2].clwt}
            ] 
            centerData1.forEach(item =>{
              // let value = getNum(item.value)
              item.arr = getNum(item.value)
            })
            state.centerData1 = centerData1
            // 视频
            state.options.src = data[3].sxt
          //  state.options.src= "https://cdn.jsdelivr.net/gh/xdlumia/files/video-play/IronMan.mp4"
          // 中间二  
            let center3Data = [
              {id:1,name:"技术指导",value:data[4].jszd,dw:"人"},
              {id:2,name:"花生代卖",value:data[4].hsdm,dw:"吨"},
              {id:3,name:"服务企业",value:data[4].fwqy,dw:"家"}
            ]
            center3Data.forEach(item =>{
              // let value = getNum(item.value)
              item.arr = getNum(item.value)
            })
            state.center3Data = center3Data
          // 中间
            state.center4Data = [
              {id:1,tit:"巡田问题",pro:data[5].xtwe},
              {id:2,tit:"问题分析",pro:data[5].xtwtfx},
              {id:3,tit:"作业指令",pro:data[5].zyzl}
            ]  
          //  右一  
          // state.right1Data = [
          //   {id:1,name:"空气温度",value:data[6].cgq.kqwd,unit:"℃",icon:require('../assets/images/jc1.png')},
          //   {id:2,name:"空气湿度",value:data[6].cgq.kqsd,unit:"%",icon:require('../assets/images/jc2.png')},
          //   {id:3,name:"土壤湿度",value:data[6].cgq.trsd,unit:"%",icon:require('../assets/images/jc3.png')},
          //   {id:4,name:"土壤温度",value:data[6].cgq.trwd,unit:"℃",icon:require('../assets/images/jc4.png')},
          //   {id:5,name:"光照",value:data[6].cgq.kqgz,unit:"lux",icon:require('../assets/images/jc5.png')},
          //   {id:6,name:"ph值",value:data[6].cgq.trph,unit:"",icon:require('../assets/images/jc6.png')},
          //   {id:7,name:"氮",value:data[6].cgq.trdhl,unit:"mg/kg",icon:require('../assets/images/jc7.png')},
          //   {id:8,name:"磷",value:data[6].cgq.trlhl,unit:"mg/kg",icon:require('../assets/images/jc7.png')},
          //   {id:9,name:"钾",value:data[6].cgq.trjhl,unit:"mg/kg",icon:require('../assets/images/jc7.png')},
          //   {id:10,name:"风速",value:data[6].cgq.kqfs,unit:"m/s",icon:require('../assets/images/jc10.png')},
          //   {id:11,name:"雨量",value:data[6].cgq.kqyl,unit:"mm",icon:require('../assets/images/jc11.png')},
          //   {id:12,name:"风向",value:data[6].cgq.kqfx,unit:"",icon:require('../assets/images/jc12.png')},
          // ]
          //  右二 
          // state.right2Data = [
          //   {id:1,name:"土壤壤情预警",value:data[6].trxqyj,icon:require('../assets/images/tr.png')},
          //   {id:2,name:"农作物苗情预警",value:data[6].nzwnqyj,icon:require('../assets/images/mq.png')},
          //   {id:3,name:"病虫害灾害预警",value:data[6].bchyj,icon:require('../assets/images/bc.png')},
          //   {id:4,name:"气象灾害预警",value:data[6].qxzhyj,icon:require('../assets/images/qx.png')},
          // ] 

        });
    }
   
    function tapVideoShow(){
      state.videoShow = true
    }

    function init() {
      container = document.createElement("div");
      document.getElementById("iviewBg").appendChild(container);

      //创建透视相机
      camera = new THREE.PerspectiveCamera(
        75, //摄像机视锥体垂直视野角度
        window.innerWidth / window.innerHeight, //摄像机视锥体长宽比
        1, //摄像机视锥体近端面
        10000 //摄像机视锥体远端面
      );

      //设置相机z轴视野
      camera.position.z = 1500;

      //创建场景
      scene = new THREE.Scene();

      const numParticles = props.amountX * props.amountY;

      const positions = new Float32Array(numParticles * 3);
      const scales = new Float32Array(numParticles);

      let i = 0,
        j = 0;

      // 初始化粒子位置和大小
      for (let ix = 0; ix < props.amountX; ix++) {
        for (let iy = 0; iy < props.amountY; iy++) {
          positions[i] = ix * SEPARATION - (props.amountX * SEPARATION) / 2; // x
          positions[i + 1] = 0; // y
          positions[i + 2] = iy * SEPARATION - (props.amountY * SEPARATION) / 2; // z
          scales[j] = 1;
          i += 3;
          j++;
        }
      }

      //是面片、线或点几何体的有效表述。包括顶点位置，面片索引、法相量、颜色值、UV 坐标和自定义缓存属性值。使用 BufferGeometry 可以有效减少向 GPU 传输上述数据所需的开销
      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute(
        "position",
        new THREE.BufferAttribute(positions, 3)
      );
      geometry.setAttribute("scale", new THREE.BufferAttribute(scales, 1));

      //着色器材质(ShaderMaterial),设置球的大小，颜色，等
      const material = new THREE.ShaderMaterial({
        uniforms: {
          //设置球的颜色
          color: { value: new THREE.Color(props.color) },
        },
        //控制球的大小
        vertexShader:
          "attribute float scale; void main() {vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );gl_PointSize = scale * ( 200.0 / - mvPosition.z );gl_Position = projectionMatrix * mvPosition;}",
        fragmentShader:
          "uniform vec3 color;void main() {if ( length( gl_PointCoord - vec2( 0.5, 0.5 ) ) > 0.475 ) discard;gl_FragColor = vec4( color, 1.0 );}",
      });

      //一个用于显示点的类。
      particles = new THREE.Points(geometry, material);
      //往场景中添加点
      scene.add(particles);

      //alpha - canvas是否包含alpha (透明度)。默认为 false。
      //渲染器的背景色默认为黑色，设置渲染器的背景色为透明
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setClearAlpha(0);
      renderer.setSize(window.innerWidth, window.innerHeight);
      container.appendChild(renderer.domElement);

      //显示右上角fps框
      // stats = new Stats();
      //   container.appendChild(stats.dom);

      container.style.touchAction = "none";
      //监听鼠标移动事件
      container.addEventListener("pointermove", onPointerMove);

      //调整波浪的位置
      container.style.position = "relative";
      container.style.top = `${props.top}px`;

      window.addEventListener("resize", onWindowResize);
    }

    function render() {
      camera.position.x += (mouseX - camera.position.x) * 0.05;
      camera.position.y = 400;
      camera.lookAt(scene.position);

      const positions = particles.geometry.attributes.position.array;
      const scales = particles.geometry.attributes.scale.array;

      // 设置粒子位置和大小
      let i = 0,
        j = 0;
      for (let ix = 0; ix < props.amountX; ix++) {
        for (let iy = 0; iy < props.amountY; iy++) {
          positions[i + 1] =
            Math.sin((ix + count) * 0.3) * 50 +
            Math.sin((iy + count) * 0.5) * 50;

          scales[j] =
            (Math.sin((ix + count) * 0.3) + 1) * 10 +
            (Math.sin((iy + count) * 0.5) + 1) * 10;

          i += 3;
          j++;
        }
      }

      particles.geometry.attributes.position.needsUpdate = true;
      particles.geometry.attributes.scale.needsUpdate = true;

      renderer.render(scene, camera);

      count += 0.1;
    }

    function onWindowResize() {
      windowHalfX = window.innerWidth / 2;
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    }

    //监听鼠标移动事件
    function onPointerMove(event) {
      console.log(event);
      if (event.isPrimary === false) return;
      mouseX = event.clientX - windowHalfX;
    }

    function animate() {
      requestAnimationFrame(animate);
      render();
      //fps 实时更新
      // stats.update();
    }

    return {
      ...toRefs(state),

      timer,
      getData,
      onPlay,
      tapVideoShow,
      init,
      render,
      onWindowResize,
      onPointerMove,
      animate
    };
  },
  components: {
      footer1
  },
};
</script>
<style lang="less" scoped>

.bg{
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  img{
    width: 500px;
  }
}
#iviewBg {
  width: 100%;
  height: 100vh;
  // background: url("../src/assets/gx.png") no-repeat;
  overflow: hidden;
  // background: #000;
  position: absolute;
  top: -30px;
  left: 0;
  z-index: 999;
};
.container {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  
}
.content{
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/bt.png") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  position: relative;
  z-index: 9999;
  .bottom{
    width: 100%;
    height: 243px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .bottom1{
    width: 100%;
    height: 243px;
    position: absolute;
    bottom: 0;
    left: 0;
   -webkit-animation: guangying 2s alternate infinite;
    animation: guangying 2s alternate infinite;
    opacity: 0.5;
  }
  .title{
    width: 100%;
    height: 80px;
    animation: yinying 2s linear infinite;
    overflow: hidden;
    position: relative;
    .titleimg{
      opacity: 0.5;
      width: 300px;
      margin-top: 30px;
    }
    .btn{
      position: absolute;
      right: 36px;
      top: 40px;
      width: 124px;
      height: 43px;
      background-size: 100% 100%;
      font-size: 18px;
      line-height: 43px;
      color: #0B8F99;
      display: flex;
      align-items: center;
      img{
        width: 27px;
        height: 33px;
        margin-right: 10px;
      }
    }
  }
  .circleBox{
    width: 100%;
    height: calc(100% - 260px);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 153px;
    .circle1{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .circleA{
        width: 494px;
        height: 494px;
        position: relative;
        z-index: 999;
        transform: scale(0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s ease-out;
        cursor: pointer;
        .circleB{
          width: 438px;
          height: 438px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/nq1.png") no-repeat ;
          position: relative;
          z-index: 999;
          transform: scale(0.9);
          animation: guangying 5s linear infinite;
        }
        .info{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 90%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .fontStyle{
            margin: 10px 0;
          }
          .color1{
            color: #3AFFF8;
          }
          .color2{
            color: #25A0FF;
          }
          .color3{
            color: #FF9B3A;
          }
          .fontStyle1{
            font-size: 32px;           
            font-weight: bold;
            
          }
          .fontStyle2{ 
            color: #ECFEFD;
            font-size: 28px;
            margin-bottom: 10px;
          }
          .jiantou{
            height: 32px;
            .img2{
              animation: jiantou 2s linear infinite;
            }
          }
          
          .infoBottom{
            width: 60%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .infoBottomItem{
              display: flex;
              flex-direction: column;
              
            }
            
            span{
              display: block;
            }
            .fontStyle3{
              font-size: 32px;
              font-style: italic;  
              margin-top: -10px;
            }
            .fontStyle4{
              font-size: 16px;
              color: #ECFEFD;
              margin: 5px 0;
            }
             .fontStyle5{
              font-size: 20px;
              color: #ECFEFD;
            }
          }
        }
        
      }
      .dizuo{
        width:540px ;
        height: 114px;
        margin: -110px 30px 0 0;
        transform: scale(0.9);
        // background: #fff;
        animation: opacity 2s linear infinite;
        filter: drop-shadow(0 0 50px rgba(35, 151, 157, 1));
        // box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);
        
         
      }
    }
    .circle1:nth-child(1){
      .circleA{
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/wq1.png") no-repeat ;
      }
      .circleB{
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/nq1.png") no-repeat ;
      }
    }
    .circle1:nth-child(2){
      .circleA{
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/wq2.png") no-repeat ;
      }
      .circleB{
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/nq2.png") no-repeat ;
      }
    }
    .circle1:nth-child(3){
      .circleA{
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/wq3.png") no-repeat ;
      }
      .circleB{
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/nq3.png") no-repeat ;
      }
    }
      .circleA:hover{
        // animation: bianda .5s;
        // // transform: scale(1);
        // animation-iteration-count: 1;
        // animation-fill-mode: forwards;
        // box-shadow: 10px 10px 10px 5px #3AFFF8;
        transform: scale(1);
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);
        border-radius: 50%;
      }
  }
}

@keyframes bianda {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      transform: scale(0.8);
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  // 50%{
  //   transform: scale(1);
  // }
   100%{
    transform: scale(1);
  }
}

@keyframes yinying {    /*引用动画名称*/
  /* from表示动画的开始位置，也可以使用0%来表示。 */
  0%{                     
      mask: linear-gradient(135deg, #028BA0 40%, #028BA0, #EEFAFE 60%);
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  100%{
    mask: linear-gradient(0deg, #028BA0 0%, #028BA0, #EEFAFE 60%);
  }
}

@keyframes jiantou {    /*引用动画名称*/
  0% {
          padding: 0;
      }
    50% {
      padding: 10px;
  }

  100% {
      padding-top: 0;
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(-360deg);
  }
}
/* 定义关键帧 */
@keyframes opacity {    /*引用动画名称*/
  0% {
          opacity:0.5;
          //filter: drop-shadow(0 0 50px rgba(35, 151, 157, 1));
      }

  50% {
       opacity:1;
      //  filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0.5));
  }
  100% {
          opacity:0.5;
          //filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0));
      }
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}

</style>
